import { SendMailApi } from '@/api/fetchers/send-mail.api'
import {
  getApiV1BaseUrl,
  getApiV2BaseUrl,
  ONE_HOUR_IN_SECONDS,
} from '@/constants'
import { ApiErrorType } from '@/errors/apiError'
import { Fetcher } from './fetcher'
import { AdminApi } from './fetchers/admin.api'
import { ArticleApi } from './fetchers/articles.api'
import { AuthApi } from './fetchers/auth.api'
import { BusinessCategoryApi } from './fetchers/business-categories.api'
import { ChatRoomApi } from './fetchers/chat-rooms.api'
import { CustomerEventsApi } from './fetchers/customerEvent'
import { FavouritesApi } from './fetchers/favourites.api'
import { ListingPathApi } from './fetchers/listing-path.api'
import { LocationsApi } from './fetchers/locations.api'
import { MediaApi } from './fetchers/media.api'
import { RevalidateApi } from './fetchers/revalidate.api'
import { ShopApi } from './fetchers/shop.api'
import { SupplierApi } from './fetchers/suppliers.api'
import { TagsApi } from './fetchers/tags.api'
import { UiPlacementApi } from './fetchers/ui-placement'
import { UploadsApi } from './fetchers/upload.api'
import { UserApi } from './fetchers/user.api'

export type ApiHandlerResult<T> = Promise<[ApiErrorType, null] | [null, T]>

class RoutesHandler {
  public admin: AdminApi
  public article: ArticleApi
  public auth: AuthApi
  public businessCategories: BusinessCategoryApi
  public chatRooms: ChatRoomApi
  public customerEvents: CustomerEventsApi
  public favourites: FavouritesApi
  public locations: LocationsApi
  public shop: ShopApi
  public supplier: SupplierApi
  public tags: TagsApi
  public uiPlacement: UiPlacementApi
  public user: UserApi
  public uploads: UploadsApi
  public revalidate: RevalidateApi
  public listingPath: ListingPathApi
  public sendMail: SendMailApi
  public media: MediaApi

  constructor(baseUrl: string) {
    const fetcher = new Fetcher(baseUrl, { revalidate: ONE_HOUR_IN_SECONDS })

    this.user = new UserApi(fetcher)
    this.auth = new AuthApi(fetcher)
    this.article = new ArticleApi(fetcher)
    this.tags = new TagsApi(fetcher)
    this.businessCategories = new BusinessCategoryApi(fetcher)
    this.uiPlacement = new UiPlacementApi(fetcher)
    this.favourites = new FavouritesApi(fetcher)
    this.supplier = new SupplierApi(fetcher)
    this.chatRooms = new ChatRoomApi(fetcher)
    this.admin = new AdminApi(fetcher)
    this.locations = new LocationsApi(fetcher)
    this.customerEvents = new CustomerEventsApi(fetcher)
    this.uploads = new UploadsApi(fetcher)
    this.revalidate = new RevalidateApi(fetcher)
    this.listingPath = new ListingPathApi(fetcher)
    this.sendMail = new SendMailApi(fetcher)
    this.media = new MediaApi(fetcher)
    this.shop = new ShopApi(fetcher)
  }
}

class Api {
  public be: RoutesHandler
  public feTofe: RoutesHandler
  public beV2: RoutesHandler

  constructor() {
    this.be = new RoutesHandler(getApiV1BaseUrl())
    this.beV2 = new RoutesHandler(getApiV2BaseUrl())
    this.feTofe = new RoutesHandler(`${process.env.NEXT_PUBLIC_BASE_URL}/api`)
  }
}

export const api = new Api()
